// extracted by mini-css-extract-plugin
module.exports = {"familyCardContainer":"FamilyDirectAccess_familyCardContainer__B1ikb","familyTextLabel":"FamilyDirectAccess_familyTextLabel__lPYaT"};